import { useEffect, useState } from "react";
import { Button, Form, Input, Modal, Spin, message } from "antd";
import axios from "axios";
import { useUserContext } from "../context/dashboard-context";
import Categorycard from "../components/categorycard/Categorycard";
import "./news-page.scss";
import CustomPagination from "../components/pagination";

const CategoriesPage = () => {
  const [form] = Form.useForm();
  const {
    token,
    loading,
    setLoading,
    GetCategory,
    categorys,
    setCategorys,
    totalProducts,
    setTotalProducts,
    pagesCount,
  } = useUserContext();

  const [loadingCreate, setLoadingCreate] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [nameUz, setNameUz] = useState("");
  const [nameRu, setNameRu] = useState("");
  const [nameEn, setNameEn] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const AddCategory = async () => {
    if (!token?.access) {
      message.error("Iltimos, tizimga qayta kiring. Token muddati tugagan.");
      return;
    }

    setLoadingCreate(true);
    try {
      await axios.post(
        "https://api.unit-group.uz/category/",
        {
          name_uz: nameUz,
          name_ru: nameRu,
          name_en: nameEn,
        },
        {
          headers: {
            Authorization: `Bearer ${token.access}`,
          },
        }
      );
      message.success("Kategoriya qo'shildi");
      setCurrentPage(1);
      GetCategory(1);
      handleOk();
    } catch (error) {
      console.error("Error adding category:", error);
      message.error("Kategoriya qo'shilmadi");
    } finally {
      setLoadingCreate(false);
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);
    form.resetFields();
    setNameUz("");
    setNameRu("");
    setNameEn("");
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const showModal = () => setIsModalOpen(true);

  const handleSearch = (val) => {
    if (!token?.access) {
      message.error("Token mavjud emas. Tizimga qayta kiring.");
      return;
    }

    if (!val || val.trim() === "") {
      GetCategory(1);
      return;
    }

    axios
      .get(`https://api.unit-group.uz/category/?search=${val}&page=1`, {
        headers: {
          Authorization: `Bearer ${token.access}`,
        },
      })
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : res.data?.data || [];
        setCategorys(data);
        setTotalProducts(res.data?.totalCount || 0);
      })
      .catch(() => {
        message.error("Qidiruvda xatolik");
      });

    setCurrentPage(1);
  };

  useEffect(() => {
    console.log("useEffect triggered:", {
      currentPage,
      token,
      categorys,
    });

    if (token?.access) {
      GetCategory(currentPage);
    }
  }, [currentPage, token]);

  return (
    <>
      <Spin spinning={loading}>
        <div className="news-page">
          <div className="page-top">
            <h1>Kategoriyalar</h1>
            <button onClick={showModal}>+ Kategoriya qo’shish</button>
          </div>

          <Input style={{marginBottom: "20px"}}
            placeholder="Qidirish"
            onChange={(e) => handleSearch(e.target.value)}
          />

          <div className="page-cards">
            {console.log("Rendering categories:", categorys)}
            {Array.isArray(categorys) && categorys.length > 0 ? (
              categorys.map((cat) => (
                <Categorycard
                key={cat.id}
                id={cat.id}
                name_uz={cat.name_uz}
                name_ru={cat.name_ru}
                name_en={cat.name_en}
                featuredproduct={false}
                GetCategory={() => GetCategory(currentPage)}
                type="category"
              />
              
              ))
            ) : (
              <p>Kategoriya topilmadi</p>
            )}
          </div>

          <CustomPagination
            current={currentPage}
            total={totalProducts}
            setCurrentPage={setCurrentPage}
            func={GetCategory}
          />
        </div>
      </Spin>

      <Modal
        title="Kategoriya qo’shish"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Spin spinning={loadingCreate}>
          <Form form={form} layout="vertical" onFinish={AddCategory}>
            <Form.Item
              label="Nomi uz"
              name="name_uz"
              rules={[{ required: true, message: "Majburiy maydon" }]}
            >
              <Input onChange={(e) => setNameUz(e.target.value)} />
            </Form.Item>
            <Form.Item
              label="Nomi ru"
              name="name_ru"
              rules={[{ required: true, message: "Majburiy maydon" }]}
            >
              <Input onChange={(e) => setNameRu(e.target.value)} />
            </Form.Item>
            <Form.Item
              label="Nomi en"
              name="name_en"
              rules={[{ required: true, message: "Majburiy maydon" }]}
            >
              <Input onChange={(e) => setNameEn(e.target.value)} />
            </Form.Item>
            <div className="modal-footer">
              <Button onClick={handleCancel}>Bekor qilish</Button>
              <Button type="primary" htmlType="submit">
                Qo’shish
              </Button>
            </div>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};

export default CategoriesPage;
